import { IconButton, Skeleton } from "@mui/material";
import Button from "@mui/material/Button";
import DeleteIcon from "@mui/icons-material/Delete";
import DownloadForOfflineIcon from "@mui/icons-material/DownloadForOffline";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import EditIcon from "@mui/icons-material/Edit";
import { Stack } from "@mui/system";
import { useEffect, useState } from "react";
import styled from "styled-components";
import { WarehousesIsurance } from "../../../../../services/warehouses/get-all/types";
import { dateFormating } from "../../../operator-orders-offering/helpers";
import { useMutation } from "@tanstack/react-query";
import { addWarehousesInsurance } from "../../../../../services/warehouses-insurance/add";
import { WarehousesInsuranceBody } from "../../../../../services/warehouses-insurance/add/types";
import { UploadForm } from "../upload-form";
import { emptyString } from "../../text";
import { useNavigate } from "react-router";
import { deleteWarehousesInsurance } from "../../../../../services/warehouses-insurance/delete";
import { urlOperator } from "../../../../../utils/url";
import { theme } from "../../../../../helpers/theme";
import { UpdateForm } from "../update-form";

export type WarehousesIsuranceDataTableProps = {
  ubezpieczenie: WarehousesIsurance;
  magazyn_id: string;
};

export interface ShortMenuBoxProps {
  data: WarehousesIsuranceDataTableProps;
  insuranceAdded: boolean;
  insuranceDeleted: boolean;
  insuranceUpdated: boolean;
  setInsuranceAdded: (value: boolean) => void;
  setInsuranceDeleted: (value: boolean) => void;
  setInsuranceUpdated: (value: boolean) => void;
}

export const ShortMenuBox = ({
  data,
  insuranceAdded,
  insuranceDeleted,
  insuranceUpdated,
  setInsuranceAdded,
  setInsuranceDeleted,
  setInsuranceUpdated,
}: ShortMenuBoxProps) => {
  const navigate = useNavigate();

  const [isDateExist, setIsDateExist] = useState(
    data.ubezpieczenie?.data_zakonczenia ? true : false
  );
  const [expireDate, setExpireDate] = useState(
    data.ubezpieczenie?.data_zakonczenia
      ? dateFormating(data.ubezpieczenie.data_zakonczenia)
      : emptyString
  );
  const [fileIsLoading, setFileIsLoading] = useState(false);
  const [fileIsUpdating, setFileIsUpdating] = useState(false);
  const [fieldValue, setFieldValue] = useState<File | null>(null);

  const deleteWarehousesInsuranceMutation = useMutation(
    deleteWarehousesInsurance,
    {
      onSuccess: (res) => {
        setInsuranceDeleted(true);
        navigate(urlOperator.subcontractors);
      },
      onError: (err: any) => {},
    }
  );

  const handleClickAddButton = (event: any) => {
    setFileIsLoading(true);
  };
  const handleClickEditButton = (event: any) => {
    setFileIsUpdating(true);
  };

  const handleDeleteInsurance = (id_ubezpieczenie: string) => {
    deleteWarehousesInsuranceMutation.mutate({
      id_ubezpieczenie: id_ubezpieczenie,
    });
  };

 
  if (deleteWarehousesInsuranceMutation.isLoading) {
    return (
      <Stack >
        <Skeleton variant="rounded" width={260} height={53} />
      </Stack>
    );
  }

  return (
    <>
      {fileIsLoading || fileIsUpdating ? (
        fileIsLoading ? (
          <UploadWrapper>
            <UploadForm
              setFileIsLoading={setFileIsLoading}
              setFieldValue={setFieldValue}
              setInsuranceAdded={setInsuranceAdded}
              fieldValue={fieldValue}
              magazyn_id={data.magazyn_id}
              insuranceAdded={insuranceAdded}
            />
          </UploadWrapper>
        ) : (
          <UploadWrapper>
            <UpdateForm
              setInsuranceUpdated={setInsuranceUpdated}
              setFieldValue={setFieldValue}
              fieldValue={fieldValue}
              magazyn_id={data.magazyn_id}
              insuranceUpdated={insuranceUpdated}
              setFileIsUpdating={setFileIsUpdating}
              insurance={data.ubezpieczenie}
            />
          </UploadWrapper>
        )
      ) : (
        <Wrapper>
          <MainInfo>{isDateExist ? expireDate : null}</MainInfo>

          <ActionWrapper>
            <Stack direction="row" spacing={1}>
              {isDateExist ? (
                <>
                  <a
                    href={
                      data.ubezpieczenie.url
                        ? data.ubezpieczenie.url
                        : undefined
                    }
                  >
                    <IconButton
                      sx={{ padding: "0px" }}
                      aria-label="download"
                      // onClick={() => {
                      //   console.log("Pobierz");
                      //   console.log(data.ubezpieczenie.url);

                      // }}
                    >
                      <DownloadForOfflineIcon
                        sx={{
                          color: `#008000`,
                          ":hover": {
                            color: `${theme.colors.blue01_active}`,
                          },
                        }}
                      />
                    </IconButton>{" "}
                  </a>
                  <IconButton
                    sx={{ padding: "0px" }}
                    aria-label="edit"
                    onClick={handleClickEditButton}
                  >
                    <EditIcon
                      sx={{
                        color: `${theme.colors.black_primaryText}`,
                        ":hover": {
                          color: `${theme.colors.blue01_active}`,
                        },
                      }}
                    />
                  </IconButton>
                  <IconButton
                    sx={{ padding: "0px" }}
                    aria-label="delete"
                    onClick={() => {
                      handleDeleteInsurance(
                        data.ubezpieczenie?.id_ubezpieczenie
                          ? data.ubezpieczenie?.id_ubezpieczenie
                          : ""
                      );
                    }}
                  >
                    <DeleteIcon
                      sx={{
                        color: `${theme.colors.gray01_secondaryText}`,
                        ":hover": {
                          color: `${theme.colors.blue01_active}`,
                        },
                      }}
                    />
                  </IconButton>
                </>
              ) : (
                
                <Button
                  //variant="outlined"
                  onClick={handleClickAddButton}
                  sx={{
                    width: "210px",
                    marginLeft: "-30px",

                    // color: `${theme.colors.gray01_secondaryText}}`,
                    // borderColor: `${theme.colors.gray05_input}`,
                    // ":hover": {
                    //   color: `${theme.colors.blue01_active}`,
                    //   borderColor: `${theme.colors.blue01_active}`,
                    // },
                  }}
                >
                  <ButtonMessage>
                    dodaj ubezpieczenie
                    </ButtonMessage>
                </Button>
              )}
            </Stack>
          </ActionWrapper>
        </Wrapper>
      )}
    </>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  //justify-content: space-between;
  justify-content: left
  align-items: center;
  column-gap: 20px;
  width: 100%;
`;
const MainInfo = styled.div`
  padding-left: 10px;
`;
const ActionWrapper = styled.div`
  //padding-right: 10px;
`;
const UploadWrapper = styled.div`
  width: 280px;
`;
export const ButtonMessage=styled.div`
color:#4e4e4e6b;
border:1px solid #4e4e4e6b;
padding:10px 20px;
border-radius: 8px;
&:hover, &:active {
  color: ${theme.colors.blue01_active};
  border:1px solid ${theme.colors.blue01_active};
}
`;
